import createReactComponent from '../createReactComponent';
var Redo = createReactComponent('Redo', [['path', {
  d: 'M21 7v6h-6',
  key: '3ptur4'
}], ['path', {
  d: 'M3 17a9 9 0 019-9 9 9 0 016 2.3l3 2.7',
  key: 'oklwrn'
}]]);
export default Redo;